import { round } from './number';

/**
 * Computes tight fitting viewbox for SVG
 *
 * @param svg SVG string
 * @returns viewbox '0 0 0 0' string
 */
const computeSvgViewBox = (svg: string) => {
  const div = document.createElement('div');
  div.innerHTML = svg;

  document.body.appendChild(div);

  const svgElement = div.querySelector('svg');
  const box = (svgElement as SVGGraphicsElement)?.getBBox();

  div.remove();

  if (!box || !svgElement) {
    return '';
  }
  return [round(box.x), round(box.y), round(box.width), round(box.height)].join(' ');
};

export { computeSvgViewBox };
